<template>
  <MainLayout selectMenu="5-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Tabs v-model="libaryMode" type="card" class="custom-tabs">
  
        <TabPane :label="getTranslation('k004')" name="m2" class="custom-tabpane">
          <SystemCompare v-if="libaryMode == 'm2'"></SystemCompare>
        </TabPane>
        <TabPane :label="getTranslation('m092')" name="m3" class="custom-tabpane">
          <ProgramCompare v-if="libaryMode == 'm3'"></ProgramCompare>
        </TabPane>
      </Tabs>
      <Modal v-model="confirmDeleteDialog" @on-ok="delAct" :okText="getTranslation('b181')"
        :cancelText="getTranslation('b182')">
        <p>{{ getTranslation('b055') }}</p>
      </Modal>
      <DownloadLibrary v-model="modalVisible" :propVisible="modalVisible" :libraryId="selectProgramId"
        :downloadMode="downloadMode"></DownloadLibrary>
    </div>
  </MainLayout>
</template>

<script>
/* eslint-disable */
import MainLayout from '@/components/MainLayout.vue'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import {
  formatToTwoDecimals,
  getNestedValue,
} from '@/util/numberFormat';
import SystemCompare from './components/SystemCompare.vue';
import ProgramCompare from './components/ProgramCompare.vue';
import DownloadLibrary from './components/DownloadLibrary.vue';
import { mapGetters } from 'vuex'
import NoAuth from '@/components/NoAuth.vue'
import { postJsError } from '@/util/util.js'
export default {
  name: 'LibraryIndex', // 组件名称
  components: {
    MainLayout,  SystemCompare, ProgramCompare, DownloadLibrary,
    NoAuth
  },
  props: {

  },
  data() {
    return {
      selectLibrary: {},
      selectLibraryId: -1,
      libaryMode: 'm2',
      modalVisible: false,
      downloadMode: '',
      originLibrary: {
        program_id: 0,
        weld_program: '',
        crr_min_weld1: 0.00,
        crr_max_weld1: 0.00,
        crr_min_weld2: 0.00,
        crr_max_weld2: 0.00,
        crr_min_weld3: 0.00,
        crr_max_weld3: 0.00,
        tim_pre_press: 0,
        pss_pre_press: 0.00,
        tim_more_press: 0,
        pss_more_press: 0.00,
        opt_pre_weld: 1,
        crr_pre_weld: 0.00,
        tim_pre_weld: 0,
        pss_pre_weld: 0.00,
        tim_cold0: 0,
        pss_cold0: 0,
        tim_ascent_weld: 0,
        pss_ascent_weld: 0.00,
        opt_weld1: 0,
        crr_weld1: 0.00,
        tim_weld1: 0,
        pss_weld1: 0,
        tim_cold1: 0,
        pss_cold1: 0.00,
        opt_weld2: 0,
        crr_weld2: 0.00,
        tim_weld2: 0,
        pss_weld2: 0.00,
        tim_cold2: 0,
        pss_cold2: 0,
        num_weld_pulse2: 0,
        opt_weld3: 0,
        crr_weld3: 0.00,
        tim_weld3: 0,
        pss_weld3: 0,
        tim_descend_weld: 0,
        pss_descend_weld: 0.00,
        tim_cold3: 0,
        pss_cold3: 0,
        opt_post_weld: 0,
        crr_post_weld: 0.00,
        tim_post_weld: 0,
        pss_post_weld: 0,
        tim_keep: 0,
        pss_keep: 0,
        tim_release: 0,
        pss_release: 0.00,
        opt_power_control: 0,
        is_uir_curve: 0,
        opt_gun_num: 0,
        val_expulsion_cnt: 0,
        val_expulsion_res_dec: 0,
        val_expulsion_time: 0,
        val_weld_rest_ref: 0,
        val_res_min: 0,
        val_res_max: 0
      },
      allLibrary: [],
      lockGet: [],
      confirmDeleteDialog: false,
      hasAuth: true,
    }

  },
  computed: {
    ...mapGetters(['getTranslation']),
    powControlList() {
      return [
        this.getTranslation("b016"),
        this.getTranslation("b017"),
        this.getTranslation("b015"),
      ]
    },
    weldList() {
      let rs = [];
      if (this.selectLibrary && this.selectLibrary.opt_power_control !== undefined) {
        let val = parseInt(this.selectLibrary.opt_power_control)

        switch (val) {
          case 0:
            rs = [
              {
                "key": 0,
                "value": this.getTranslation("b016"),
              }
            ]
            break;
          case 1:
            rs = [
              {
                "key": 1,
                "value": this.getTranslation("b017"),
              }
            ]
            break;
          case 2:
            rs = [
              {
                "key": 0,
                "value": this.getTranslation("b016"),
              },
              {
                "key": 1,
                "value": this.getTranslation("b017"),
              }
            ]
            break;
          default:
            break;
        }
      } else {
        rs = [
          {
            "key": 0,
            "value": this.getTranslation("b016"),
          },
          {
            "key": 1,
            "value": this.getTranslation("b017"),
          }
        ]
      }
      return rs;
    },
    // 格式化数值属性为两位小数
    formattedCrrMinWeld1: {
      get() {
        if (this.lockGet[0]) {
          this.lockGet[0] = false;
          return this.selectLibrary.crr_min_weld1;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_min_weld1'));
        }
      },
      set(value) {
        this.lockGet[0] = true;
        this.$set(this.selectLibrary, 'crr_min_weld1', value);
      }
    },
    formattedCrrMinWeld2: {
      get() {
        if (this.lockGet[1]) {
          this.lockGet[1] = false;
          return this.selectLibrary.crr_min_weld2;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_min_weld2'));
        }
      },
      set(value) {
        this.lockGet[1] = true;
        this.$set(this.selectLibrary, 'crr_min_weld2', value);
      }
    },
    formattedCrrMinWeld3: {
      get() {
        if (this.lockGet[2]) {
          this.lockGet[2] = false;
          return this.selectLibrary.crr_min_weld3;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_min_weld3'));
        }
      },
      set(value) {
        this.lockGet[2] = true;
        this.$set(this.selectLibrary, 'crr_min_weld3', value);
      }
    },
    formattedCrrMaxWeld1: {
      get() {
        if (this.lockGet[3]) {
          this.lockGet[3] = false;
          return this.selectLibrary.crr_max_weld1;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_max_weld1'));
        }
      },
      set(value) {
        this.lockGet[3] = true;
        this.$set(this.selectLibrary, 'crr_max_weld1', value);
      }
    },
    formattedCrrMaxWeld2: {
      get() {
        if (this.lockGet[4]) {
          this.lockGet[4] = false;
          return this.selectLibrary.crr_max_weld2;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_max_weld2'));
        }
      },
      set(value) {
        this.lockGet[4] = true;
        this.$set(this.selectLibrary, 'crr_max_weld2', value);
      }
    },
    formattedCrrMaxWeld3: {
      get() {
        if (this.lockGet[5]) {
          this.lockGet[5] = false;
          return this.selectLibrary.crr_max_weld3;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_max_weld3'));
        }
      },
      set(value) {
        this.lockGet[5] = true;
        this.$set(this.selectLibrary, 'crr_max_weld3', value);
      }
    },
    formattedCrrPreWeld: {
      get() {
        if (this.lockGet[6]) {
          this.lockGet[6] = false;
          return this.selectLibrary.crr_pre_weld;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_pre_weld'));
        }
      },
      set(value) {
        this.lockGet[6] = true;
        this.$set(this.selectLibrary, 'crr_pre_weld', value);
      }
    },
    formattedCrrWeld1: {
      get() {
        if (this.lockGet[7]) {
          this.lockGet[7] = false;
          return this.selectLibrary.crr_weld1;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_weld1'));
        }
      },
      set(value) {
        this.lockGet[7] = true;
        this.$set(this.selectLibrary, 'crr_weld1', value);
      }
    },
    formattedCrrWeld2: {
      get() {
        if (this.lockGet[8]) {
          this.lockGet[8] = false;
          return this.selectLibrary.crr_weld2;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_weld2'));
        }
      },
      set(value) {
        this.lockGet[8] = true;
        this.$set(this.selectLibrary, 'crr_weld2', value);
      }
    },
    formattedCrrWeld3: {
      get() {
        if (this.lockGet[9]) {
          this.lockGet[9] = false;
          return this.selectLibrary.crr_weld3;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_weld3'));
        }
      },
      set(value) {
        this.lockGet[9] = true;
        this.$set(this.selectLibrary, 'crr_weld3', value);
      }
    },
    formattedCrrPostWeld: {
      get() {
        if (this.lockGet[10]) {
          this.lockGet[10] = false;
          return this.selectLibrary.crr_post_weld;
        } else {
          return formatToTwoDecimals(getNestedValue(this.selectLibrary, 'crr_post_weld'));
        }
      },
      set(value) {
        this.lockGet[10] = true;
        this.$set(this.selectLibrary, 'crr_post_weld', value);
      }
    },
    selectProgramId() {
      let rs = -1;
      if (this.allLibrary && this.allLibrary.length > 0) {
        this.allLibrary.forEach(item => {
          if (item.id == this.selectLibraryId) {
            rs = item.program_id;
          }
        })

      }
      return rs;
    }
  },
  watch: {
    // 监听selectLibrary变化，强制计算属性重新计算
    selectLibrary: {
      handler(newVal) {
        if (newVal) {
          // 当数据变化时，使用$nextTick确保计算属性重新计算
          this.$nextTick(() => {
            // 这里不需要做任何操作，Vue会自动处理计算属性的依赖
          });
        }
      },
      deep: true,
      immediate: true
    },
    libaryMode: function (newVal) {
      localStorage.setItem('library.tab', newVal);
    }

  },
  mounted() {

  },
  created() {
    this.libaryMode = localStorage.getItem('library.tab') || 'm2';
    this.setBreadcrumbItems();
    this.getLibrary();
  },
  methods: {
    getLibrary(id) {
      let url = API_URL["libraryGetAll"];
      axios.get(url)
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.allLibrary = res.data.data || [];
            if (id) {
              this.$nextTick(() => {
                this.selectLibraryId = id;
                this.libraryChange();
              });
            } else {
              // 如果有数据，总是选择第一个项目；如果没有数据，设置为-1
              if (this.allLibrary && this.allLibrary.length > 0) {
                this.selectLibraryId = this.allLibrary[0].id;
              } else {
                this.selectLibraryId = -1;
              }
              this.libraryChange();
            }

          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    add() {
      let params = {};
      let url = API_URL["libraryAdd"];
      params = this.originLibrary;
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$Message.success(this.getTranslation('b042'));
            this.getLibrary(res.data.data);

          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    update() {
      if (!this.validateForm()) {
        return;
      }
      let params = {};
      let url = API_URL["libraryUpdate"];
      params = this.selectLibrary;
      if (!this.selectLibrary.id) {
        this.$Message.error(this.getTranslation('b206'));
        return
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$Message.success(this.getTranslation('b044'));
            this.getOneLibrary(this.selectLibrary.id);

          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    clear() {
      if (!this.selectLibrary || !this.selectLibrary.id) {
        this.$Message.error(this.getTranslation('b053'));
        return
      }
      let id = this.selectLibraryId;
      let program_id = this.selectLibrary.program_id;
      this.selectLibrary = { ...this.originLibrary };
      this.selectLibrary.program_id = program_id;
      this.selectLibrary.id = id;

    },
    copy() {
      if (!this.selectLibrary || !this.selectLibrary.id) {
        this.$Message.error(this.getTranslation('b054'));
        return
      }
      let params = {};
      let url = API_URL["libraryCopy"];
      params = { id: this.selectLibrary.id }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$Message.success(this.getTranslation('b051'));
            this.getLibrary(res.data.data);
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })

    },
    del() {
      this.confirmDeleteDialog = true;
    },
    delAct() {
      if (!this.selectLibrary || !this.selectLibrary.id) {
        this.$Message.error(this.getTranslation('b052'));
        return
      }
      let params = {};
      let url = API_URL["libraryDelete"];
      params = { id: this.selectLibrary.id }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$Message.success(this.getTranslation('b046'));
            // 删除成功后重置selectLibraryId为-1，确保Select组件能正确更新
            this.selectLibraryId = -1;
            this.getLibrary();
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    getOneLibrary(id) {
      let url = API_URL["libraryGetOne"];
      let params = {
        id: id
      };
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$nextTick(() => {
              // 直接替换对象，自定义指令会自动处理格式化
              this.selectLibrary = { ...res.data.data };
              this.allLibrary.forEach((item,key) => {
                if (item.id == this.selectLibraryId) {
                  // 直接替换对象，自定义指令会自动处理格式化                  
                  this.allLibrary[key] = { ...this.selectLibrary}
                }
              })
            })
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    libraryChange() {
      if (this.allLibrary && this.allLibrary.length > 0) {
        if (this.selectLibraryId > -1) {
          this.allLibrary.forEach(item => {
            if (item.id == this.selectLibraryId) {
              // 直接替换对象，自定义指令会自动处理格式化
              this.selectLibrary = { ...item };
            }
          })
        } else {
          // 如果没有选中任何项，清空selectLibrary数据
          this.selectLibrary = { ...this.originLibrary };
        }
      } else {
        // 如果没有数据，也清空selectLibrary数据
        this.selectLibrary = { ...this.originLibrary };
      }
    },
    validateForm() {
      let errorMsg = '';
      let isValid = true;
      if (!this.selectLibrary.weld_program) {
        isValid = false;
        errorMsg = this.getTranslation('b049');
      }
      if (errorMsg) {
        this.$Message.error(errorMsg);
      }
      return isValid;
    },
    downloadOne() {
      this.downloadMode = 'one';
      this.modalVisible = true;
    },
    downloadBatch() {
      this.downloadMode = 'batch';
      this.modalVisible = true;
    },
    changePowerControl(val) {
      this.$nextTick(() => {
        switch (val) {
          case 0:
            this.selectLibrary.opt_weld1 = 0
            this.selectLibrary.opt_weld2 = 0
            this.selectLibrary.opt_weld3 = 0
            break;
          case 1:
            this.selectLibrary.opt_weld1 = 1
            this.selectLibrary.opt_weld2 = 1
            this.selectLibrary.opt_weld3 = 1
            break
          default:
            break;
        }
      })
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['p089']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('p089') }
        ])
      }      
    }
  },

}
</script>
<style scoped>
/* 自定义Tabs容器样式 */
@import url("../../assets/style/list.css");
@import url("../../assets/style/tab.css");

.other-line {
  margin-top: 20px;
}

.other-line .input {
  width: 90%;
}

.other-line .row-line {
  margin: 4px 0;
}

.other-img {
  width: 17px;
}
</style>
